import { Switch } from "../ui/switch"
import { Collapse } from "@mantine/core"
import FormField from "./FormField"
import { useWatch } from "react-hook-form"

interface SwitchCollapseInputProps extends React.ComponentProps<typeof Switch> {
  label: React.ReactNode
  children: React.ReactNode
  form: any
  name: string
}

function SwitchCollapseInput({ label, children, form, name, ...props }: SwitchCollapseInputProps) {
  // const [enabled, setEnabled] = useState(props.defaultValue || props.checked)
  const enabled = useWatch({ control: form.control, name })

  return (
    <DrawerLabelField
      label={label}
      right={
        <FormField name={name}>
          <Switch {...props} />
        </FormField>
      }
    >
      <Collapse in={!!enabled} transitionTimingFunction={"linear"} transitionDuration={100}>
        <DrawerLabelBox>{children}</DrawerLabelBox>
      </Collapse>
    </DrawerLabelField>
  )
}

export const DrawerLabelBox = ({ children }: { children: React.ReactNode }) => (
  <div className="bg-ground/50 rounded-2xl p-5">{children}</div>
)

export const DrawerLabelField = ({
  label,
  children,
  right,
}: {
  label: React.ReactNode
  children?: React.ReactNode
  right?: React.ReactNode
}) => (
  <div className="flex flex-col gap-4 px-4">
    <div className="flex items-center justify-between gap-2">
      <span className="font-semibold text-[15px]">{label}</span>
      {right}
    </div>
    {children}
  </div>
)

export default SwitchCollapseInput
